import {BlobInjector} from '../../components/blob-injector.js';
import {Puzzle} from '../../components/puzzle.js';
import {DefaultGameRules} from '../../components/rules/default-game-rules.js';
import {Statistics} from '../../components/statistics.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';
import {WLUtils} from '../../utils/WLUtils.js';
import {PowerupPerk} from '../PowerupPerk.js';

type RangeChange = {
    minTurns: number;
    maxTurns: number;
    spawnAtStartup: number;
};
/**
 * TNT Powerup Perk
 * The original in Unity was called `ModifyInjectorByStat`
 */
export class TNTPowerupPerk extends PowerupPerk {
    perkStat: TransactionalNames = TransactionalNames.TNTUpgrade;
    tagToAdjust = 'TNT';

    private _upgrade1: RangeChange = {minTurns: 35, maxTurns: 45, spawnAtStartup: 1};
    private _upgrade2: RangeChange = {minTurns: 30, maxTurns: 40, spawnAtStartup: 1};
    private _upgrade3: RangeChange = {minTurns: 25, maxTurns: 35, spawnAtStartup: 2};
    private _upgrade4: RangeChange = {minTurns: 20, maxTurns: 30, spawnAtStartup: 2};
    private _upgrade5: RangeChange = {minTurns: 15, maxTurns: 25, spawnAtStartup: 3};

    // // Use this for initialization
    execute() {
        let addProbability = Statistics.instance.getTransactional(this.perkStat);
        let upgrade = this._upgrade1;
        switch (addProbability) {
            case 1:
                upgrade = this._upgrade1;
                break;
            case 2:
                upgrade = this._upgrade2;
                break;
            case 3:
                upgrade = this._upgrade3;
                break;
            case 4:
                upgrade = this._upgrade4;
                break;
            case 5:
                upgrade = this._upgrade5;
                break;
        }

        if (Puzzle.instance.rules instanceof DefaultGameRules) {
            const myRules = Puzzle.instance.rules as DefaultGameRules;
            if (myRules.lineSpawnerObject != null) {
                const injectors = WLUtils.getComponentsOfType(
                    myRules.lineSpawnerObject,
                    BlobInjector
                );
                for (let x = 0; x < injectors.length; x++) {
                    const injector = injectors[x];
                    if (injector.prefabTag == this.tagToAdjust) {
                        injector.overrideSettings(
                            upgrade.minTurns,
                            upgrade.maxTurns,
                            upgrade.spawnAtStartup
                        );
                        //  recompute next injection
                        injector.computeNextInjectTurn();
                    }
                }
            }
        }
    }
}
